import { NgIf, AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { CmsParagraphComponent } from '@spartacus/core'
import { CmsComponentData } from '@spartacus/storefront'

@Component({
  selector: 'eb-paragraph',
  templateUrl: './eb-paragraph.component.html',
  styleUrls: ['./eb-paragraph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EbParagraphComponent {
  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    public sanitizer: DomSanitizer
  ) {}
}
